import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthService, User } from '@auth0/auth0-angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProfileComponent implements OnInit {
  profile: User | null | undefined = null;

  constructor(public auth: AuthService, public translate: TranslateService) {}

  ngOnInit() {
    window.scrollTo(0, 0);
    this.auth.user$.subscribe((profile) => (this.profile = profile));
  }
}
